import React from 'react'
import { SVGProps } from './types'

export const NavContacts: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path d="M2 6h4" fill="none" />
      <path d="M2 10h4" fill="none" />
      <path d="M2 14h4" fill="none" />
      <path d="M2 18h4" fill="none" />
      <rect width="16" height="20" x="4" y="2" rx="2" fill="none" />
      <path d="M16 2v20" fill="none" />
    </svg>
  )
}
